import Axios, {AxiosResponse} from "axios";
import RootApi from "./root-api";

export default class BlogApi extends RootApi {
    private readonly apiEndpoint: string = `${this.ApiRoot}/blog/posts`;

    public async getPosts(): Promise<AxiosResponse> {
        return await Axios.get(this.apiEndpoint);
    }

    public async getPostDetails(id: number): Promise<AxiosResponse> {
        return await Axios.get(`${this.apiEndpoint}/${id}`);
    }
}



// WEBPACK FOOTER //
// ./src/api/blog-api.ts